import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react'
import { ObservableValue } from '../state/ObservableValue'

export function useObservableState<T>(state: ObservableValue<T>): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(state.value)
  const valueRef = useRef(value)
  valueRef.current = value

  const setObservableValue: Dispatch<SetStateAction<T>> = useCallback(
    (arg) => {
      if (typeof arg === 'function') {
        const fn = arg as (prevState: T) => T
        state.value = fn(valueRef.current)
      } else {
        state.value = arg
      }
    },
    [state],
  )

  useEffect(() => state.subscribe((v) => setValue(v)), [state])

  return [value, setObservableValue]
}
